import { Component, OnInit } from '@angular/core';

@Component( {
    selector: 'ridango-block-items-three',
    templateUrl: './block-items-three.component.html',
    styleUrls: [ './block-items-three.component.css' ]
} )
export class BlockItemsThreeComponent implements OnInit {
    constructor() { }
    ngOnInit () { }
}
